import { DependencyList, EffectCallback, useEffect } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { PlayerAdapter } from '../types/instance';

export const useInstanceEffect = (
    callback: (instance: PlayerAdapter) => ReturnType<EffectCallback>,
    deps: DependencyList = []
) => {
    const instance = usePlayerInstance();

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (instance) {
            return callback(instance);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance, ...deps]);
};
